import React from 'react';
import {useChart} from '../hooks';
import styled from 'styled-components';
import * as am4charts from "@amcharts/amcharts4/charts";


const StyledChartWrapper = styled.div`
    height: 480px;
    width: 100%;
`;


export default function ({data}) {
    const [ref, chart] = useChart({
        data,
        "xAxes": [{
            "type": "ValueAxis",
            "dataFields": {
                "category": "title",

            },

        }],
        "yAxes": [{
            "type": "ValueAxis",
            "dataFields": {
                "category": "title",

            },

        }],
        "series": [{
            "type": "LineSeries",
            "dataFields": {
                "valueX": "x",
                "valueY": "y",

            },

        }],
    }, am4charts.XYChart);

    // const row = JSON.parse(data[0])
    // console.log('row[0]',data[0])

    // const newData = []
    //
    //
    // const makeData = () => {
    //   const newData = []
    //
    //   row[0].forEach((item, i) => {
    //     // console.log('for', item)
    //     newData.push({item})
    //   });
    //
    //   // console.log('newData',newData)
    // }

    React.useEffect(
      () => {
        if (!chart) {
          return
        }
        chart.data = data[0]
        chart.invalidateData()
      }, [data]
    )


    return (
      <StyledChartWrapper ref={ref}/>
    )
}
